/**
 * Monotonic ULID (Crockford base32, 10 time chars + 16 random chars).
 * ZOD-FREE and dependency-free — bundled into the SDK.
 */
const B32 = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';

let lastTime = -1;
let lastRand: number[] = [];

function randomBytes(n: number): number[] {
	const out = new Array<number>(n);
	const c = typeof crypto !== 'undefined' ? crypto : undefined;
	if (c && typeof c.getRandomValues === 'function') {
		const buf = new Uint8Array(n);
		c.getRandomValues(buf);
		for (let i = 0; i < n; i++) out[i] = buf[i] & 31;
	} else {
		for (let i = 0; i < n; i++) out[i] = Math.floor(Math.random() * 32);
	}
	return out;
}

/** Generate a ULID; monotonic within the same millisecond. */
export function ulid(now?: number): string {
	let t = now ?? Date.now();
	if (t === lastTime) {
		// increment the random part (base32, little-endian carry from the right)
		for (let i = 15; i >= 0; i--) {
			if (lastRand[i] < 31) {
				lastRand[i]++;
				break;
			}
			lastRand[i] = 0;
		}
	} else {
		lastTime = t;
		lastRand = randomBytes(16);
	}
	let time = '';
	for (let i = 9; i >= 0; i--) {
		time = B32[t % 32] + time;
		t = Math.floor(t / 32);
	}
	let rand = '';
	for (let i = 0; i < 16; i++) rand += B32[lastRand[i]];
	return time + rand;
}

export const ULID_RE = /^[0-9A-HJKMNP-TV-Z]{26}$/;
